import { ContextMenuContext } from './Contexts';
import { useContext, useCallback, useState, useEffect, useMemo } from 'react';
import ContextMenu from './ContextMenu';
import ChooseCropIcon from './ChooseCropIcon';
import CropIcon from '@material-ui/icons/Crop';

import { MouseAvailabilityContext } from './MouseFocusProvider'; 
import { FigureInteractionEventDispatch,SelectedItemsContext } from './Contexts';
import { SelectedItemInfo } from './SelectedItemProvider';

import { SelectedItemsDispatch,  } from './SelectedItemProvider';


const menuItemToActionMap = {
  editRegion:"specifyExpansionNodeRegion",
  setRegionVariable:"specifyExpansionNodeRegion",
}
const menuItemToTitleMap = {


  //FONT SIZE WON'T WORK
  //BECAUSE THESE ARE HARD-CODED SVGs
  //AND I HAVEN'T CODED THE ABILITY TO SCALE THEM!
  editRegion:(
    <div class="sg-row v-center">
      <CropIcon style={{color:'#666', fontSize:10}}/>
      <span style={{paddingLeft:5}}>Edit subregion</span>
    </div>
  ),
  setRegionVariable:(
    <div class="sg-row v-center">
      <ChooseCropIcon style={{color:'#666', fontSize:10}}/>
      <span style={{paddingLeft:5}}>Choose region</span>
    </div>
  )
}

const eventOnContextMenu = e => {

  let path = e.composedPath();
  let containsContextMenu = path.find(comp => comp.className && comp.className.includes && comp.className.includes('sg-context-menu'));

  return containsContextMenu;


}

function getItemCssSelector(selectedFigureItems){

  let { cells, expansionNodes } = selectedFigureItems;
    let cssSelector;
  if( expansionNodes && expansionNodes.length > 0 ){
      let nodeId = expansionNodes[0].nodeId;
      return `[nodeId="${nodeId}"]`;
    }else if( cells && cells.length > 0 ){
      return `#grid-${cells[0].join('-')}`;
    }
}

export default function FigureEditorContextMenuLayer({
  children, 
  figurePanelId,
}){


  const { requestMouseFocus } = useContext(MouseAvailabilityContext);

  const selectedFigureItems = useContext(SelectedItemsContext);
  const setSelectedItems = useContext(SelectedItemsDispatch);


  const setSelectedCells = useCallback(cells => setSelectedItems({cells}));

  const onEvent = useContext(FigureInteractionEventDispatch);

  const {possibleActions} = useContext(SelectedItemInfo);


  let selectedCells = selectedFigureItems.cells;

  let [contextMenuInfo, _setContextMenuInfo] = useState();

  const setContextMenuInfo = useCallback(args => {
    if( !contextMenuInfo && !args ){
      return;
    }
    _setContextMenuInfo(args);
  },[contextMenuInfo,_setContextMenuInfo])


  let { location, items } = contextMenuInfo || {};


    let menuLocations = [];
    let urgentActions = Object.entries(possibleActions||{}).filter(([key,value]) => value?.urgent)

  let cssSelector = getItemCssSelector(selectedFigureItems);
  if( urgentActions.length > 0 ){
    
    menuLocations = Array.from(document.querySelectorAll(cssSelector)).slice(-1).map(r => {
      let domRect = r.getBoundingClientRect();
      let jsRect = { x:domRect.x, y:domRect.y, w:domRect.width, h:domRect.height };
      return jsRect;
    })
  }


  if( urgentActions.length > 0 ){

    items = urgentActions.map(([key,value]) => {
      let type = (menuItemToActionMap[key] || key)
      return {
        type,
        action:type,
        title:(menuItemToTitleMap[key]||type),
        args:value,
      }
    })

  }


  let locis = []
  if( location ){
    locis.push(location);
  }else{
    //locis.push(...menuLocations);
  }



  useEffect(() => {

    const onContextMenu = e => {

      e.preventDefault();

      let path = e.composedPath();


      let contextMenuGridItem;

      for(let comp of path){
       if( comp.id?.indexOf('grid') === 0 ){
         contextMenuGridItem = comp;
         break;
       }else if( comp.id === "context-catcher" ){
         setContextMenuInfo();
         return;
      }
      }

      /*
      let expansionNodeItem = path.find( comp => comp.nodeId );
      if( expansionNodeItem ){
      }
      */

      if( contextMenuGridItem ){

        let [clickedY,clickedX] = contextMenuGridItem.id.split('-').slice(1).map(Number);



        let contextMenuOnSelectedCell = (selectedCells||[]).find(([cellY,cellX]) => {

          return ((cellY === clickedY) && (cellX === clickedX));

        })

        e.preventDefault();

        if(! contextMenuOnSelectedCell ){
          setSelectedCells([[clickedY,clickedX]])
        }

        setContextMenuInfo({location:{x:e.clientX,y:e.clientY}});

      }

    }

    function mouseDown(e){
      let onContextMenu = eventOnContextMenu(e)
      if( contextMenuInfo && !onContextMenu ){
        setContextMenuInfo();
      }else if( onContextMenu ){
        requestMouseFocus("contextmenu");
      }
    }

    const prevDev = e => e.preventDefault();

    window.addEventListener('mousedown',mouseDown)
    window.addEventListener('contextmenu', onContextMenu);
    return () => {
      window.removeEventListener('contextmenu', onContextMenu);
      window.removeEventListener('mousedown',mouseDown);
    }
  },[contextMenuInfo,selectedCells,setContextMenuInfo,setSelectedCells])


  let menu = locis.map(thisLocation => {
    return <ContextMenu {...{
      x:thisLocation.x,
      y:thisLocation.y,
      figurePanelId,

      items,

      selectedFigureItems,
      setSelectedCells,
      style:{ transform:`translate(calc(-50% + ${thisLocation.w/2}px),calc(-100% - 5px))` },

      onEvent,

      onClose:() => { 
        setContextMenuInfo(null)
      }
    }}/>});

  const wrap = false;
  if (wrap){

    menu = (<div 
      onClick={e => {
        if( contextMenuInfo ){
          setContextMenuInfo(null);
        }
      }}
      onMouseUp={e => { 

        
        
      }}
      id={"context-catcher"}

      style={{position:'fixed',
        top:0,
        left:0,
        width:'100%',
        height:'100%',
        background:'rgba(0,0,0,0.0)',
        zIndex:1000,
      }}>
      <div class="sg-row">
      {menu}
      </div>
    </div>)

  }


  let wrappedMenu = locis.length > 0 && (
    <>
      <div onMouseDown={() => {
        requestMouseFocus('contextmenu');
      }}>
        {menu}
        </div>
    </>

  )


  return (
    <ContextMenuContext.Provider value={{contextMenuInfo,setContextMenuInfo}}>
      {children}
      {wrappedMenu}
    <div class="dev-help" style={{
        position:'fixed',
        top:0,
        left:0,
        background:'black',
        zIndex:100000
      }}>
        <pre style={{color:'lime', fontWeight:'bold'}}>
          {JSON.stringify(contextMenuInfo)}
        </pre>
      </div>
    </ContextMenuContext.Provider>
  )

}
